import React, { useState, useEffect } from 'react';
import { TempalteCreate, ShowTempalte, DeleteTempalte, EditeTempalte } from "../../../services/AdminService";
import { Form } from 'react-bootstrap';
import CreateCategory from './CreateCategory';
// import './Template.css';
import '../adminportal.css';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../../../components/ModalComponent'

const Template = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newTemplate, setNewTemplate] = useState({ title: '', description: '', icon: '', tags: '', is_negotiable: false });
  const [errors, setErrors] = useState({});
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [hoveredTemplate, setHoveredTemplate] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editTemplateData, setEditTemplateData] = useState({
    uuid: '',
    title: '',
    description: '',
    icon: '',
    currentImage: '',
    tags: '',
    is_negotiable: false
  });

  useEffect(() => {
    fetchTemplates();
  }, []);

  useEffect(() => {
    if (categoriesData.length > 0 && !selectedCategory) {
      const firstCategory = categoriesData[0];
      setSelectedCategory(firstCategory.id);
      setTemplates(firstCategory.templates || []);
    }
  }, [categoriesData, selectedCategory]);

  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    if (categoriesData.length > 0) {
      const selectedCategoryData = categoriesData.find(category => category.id === categoryId);
      if (selectedCategoryData) {
        setTemplates(selectedCategoryData.templates || []);
      } else {
        setTemplates([]);
      }
    }
  };

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const response = await ShowTempalte();
      setCategoriesData(response.data?.data);

      localStorage.setItem("categoriesData", JSON.stringify(response.data?.data));

      if (selectedCategory && response.data?.data) {
        const selectedCategoryData = response.data.data.find(category => category.id === selectedCategory);
        if (selectedCategoryData) {
          setTemplates(selectedCategoryData.templates || []);
        }
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTemplate = async () => {
    const newErrors = {};
    if (!newTemplate.title) newErrors.title = 'Title is required';
    if (!newTemplate.description) newErrors.description = 'Description is required';
    if (!newTemplate.icon) newErrors.icon = 'Icon is required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const formData = new FormData();
      formData.append('category_id', selectedCategory);
      formData.append('title', newTemplate.title);
      formData.append('description', newTemplate.description);
      formData.append('image', newTemplate.icon);
      formData.append('tags', newTemplate.tags);
      formData.append('is_negotiable', newTemplate.is_negotiable ? 1 : 0);

      await TempalteCreate(formData);

      setShowModal(false);
      setNewTemplate({ title: '', description: '', icon: '', tags: '', is_negotiable: false });
      fetchTemplates();
    } catch (error) {
      setErrors({ general: error.response?.data?.message || 'Error creating template' });
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
        setErrors({ ...errors, icon: 'Please upload a PNG or JPEG image for the icon' });
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setErrors({ ...errors, icon: 'Icon image size must be less than 2MB' });
        return;
      }
      setNewTemplate({ ...newTemplate, icon: file });
      setErrors({ ...errors, icon: '' });
    }
  };

  const handleEditTemplate = async () => {
    const newErrors = {};
    if (!editTemplateData.title) newErrors.title = 'Title is required';
    if (!editTemplateData.description) newErrors.description = 'Description is required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const formData = new FormData();
      formData.append('uuid', editTemplateData.uuid);
      formData.append('title', editTemplateData.title);
      formData.append('description', editTemplateData.description);
      formData.append('tags', editTemplateData.tags);
      formData.append('is_negotiable', editTemplateData.is_negotiable ? 1 : 0);
      if (editTemplateData.icon) {
        formData.append('image', editTemplateData.icon);
      }

      await EditeTempalte(formData);
      setShowEditModal(false);
      fetchTemplates();
    } catch (error) {
      setErrors({ general: error.response?.data?.message || 'Error updating template' });
    } finally {
      setLoading(false);
    }
  };

  const handleEditFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
        setErrors({ ...errors, icon: 'Please upload a PNG or JPEG image for the icon' });
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setErrors({ ...errors, icon: 'Icon image size must be less than 2MB' });
        return;
      }
      const previewUrl = URL.createObjectURL(file);
      setEditTemplateData(prev => ({
        ...prev,
        icon: file,
        currentImage: previewUrl
      }));
      setErrors({ ...errors, icon: '' });
    }
  };

  const getSelectedCategoryName = () => {
    if (!selectedCategory || categoriesData.length === 0) return '';
    const category = categoriesData.find(cat => cat.id === selectedCategory);
    return category ? category.category_name : '';
  };

  const openEditModal = (template) => {
    setSelectedTemplate(template);
    setEditTemplateData({
      uuid: template.uuid,
      title: template.title,
      description: template.description,
      icon: '',
      currentImage: template.image_path,
      tags: template.tags ? template.tags.join(', ') : '',
      is_negotiable: Boolean(template.is_negotiable)
    });
    setShowEditModal(true);
  };

  const openDeleteModal = (template) => {
    setSelectedTemplate(template);
    setShowDeleteModal(true);
  };

  const deleteTemplate = async () => {
    if (!selectedTemplate) return;

    try {
      setLoading(true);
      await DeleteTempalte({ uuid: selectedTemplate.uuid });
      setShowDeleteModal(false);
      fetchTemplates();
      setSelectedTemplate(null);
    } catch (error) {
      setErrors({ general: error.response?.data?.message || 'Error deleting template' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" className="page-loader" />
        </div>
      )}

      <div className="admin-template-layout admin-dashboard-container">
        <aside className="admin-template-sidebar">
          <CreateCategory
            onCategorySelect={handleCategorySelect}
            categories={categoriesData}
            selectedCategory={selectedCategory}
          />
        </aside>

        <main className="admin-template-main">
          <div className="admin-template-header">
            <h2 className="admin-template-title">{getSelectedCategoryName()}</h2>
            <div className="admin-template-divider" />
          </div>

          <div className="admin-template-grid">
            {templates.map((template) => (
              <div
                key={template.uuid}
                className="admin-template-card admin-panel"
                onClick={(e) => {
                  if (
                    e.target.closest('.admin-template-action-btn')
                  ) return;
                  navigate(`/back-admin/template/${template.uuid}`);
                }}
                onMouseEnter={() => setHoveredTemplate(template.uuid)}
                onMouseLeave={() => setHoveredTemplate(null)}
              >
                <div className="admin-template-card-actions">
                  <button
                    className="admin-template-action-btn edit-btn"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Edit"
                    onClick={() => openEditModal(template)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>
                  <button
                    className="admin-template-action-btn delete-btn"
                    title="Delete"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => openDeleteModal(template)}
                  >
                    <i className="bi bi-trash3-fill"></i>
                  </button>
                </div>

                <div className="admin-template-icon-container">
                  <img src={template.image_path} alt="" className="admin-template-image" />
                </div>

                <h5 className="admin-template-card-title">
                  <span title={template.title}>{template.title}</span>
                </h5>

                <p className="admin-template-card-desc" title={template.description}>
                  {template.description}
                </p>

                <div className="admin-template-tags">
                  {template.tags && template.tags.length > 0 ? (
                    template.tags.map((tag, index) => (
                      <span key={index} className="admin-template-tag">{tag}</span>
                    ))
                  ) : (
                    <span className="admin-template-no-tags">No tags</span>
                  )}
                </div>
              </div>
            ))}

            <div className="admin-template-create-card admin-panel" onClick={() => setShowModal(true)}>
              <div className="admin-template-create-plus">+</div>
              <div className="admin-template-create-title">Create Template</div>
              <div className="admin-template-create-desc">Click to create a new document template</div>
            </div>
          </div>
        </main>
      </div>

      <ModalComponent
        show={showModal}
        handleClose={() => setShowModal(false)}
        title="Create New Template"
        size="md"
        footerButtons={[
          {
            label: "Cancel",
            variant: "outline-secondary",
            onClick: () => setShowModal(false),
          },
          {
            label: loading ? "Creating..." : "Add Template",
            variant: "primary",
            onClick: handleCreateTemplate,
            disabled: loading,
          },
        ]}
      >
        <div className='p-3'>
          {errors.general && (
            <div className="text-danger mb-4">{errors.general}</div>
          )}

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">Icon</Form.Label>
            <Form.Control
              type="file"
              accept="image/png,image/jpeg,image/jpg"
              onChange={handleFileChange}
              className="admin-template-file-input"
            />
            {errors.icon && <small className="text-danger">{errors.icon}</small>}
          </Form.Group>

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">Title</Form.Label>
            <Form.Control
              type="text"
              value={newTemplate.title}
              onChange={(e) =>
                setNewTemplate({ ...newTemplate, title: e.target.value })
              }
              className="admin-template-input"
              placeholder="Template title..."
            />
            {errors.title && <small className="text-danger">{errors.title}</small>}
          </Form.Group>

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={newTemplate.description}
              onChange={(e) =>
                setNewTemplate({ ...newTemplate, description: e.target.value })
              }
              className="admin-template-textarea"
              placeholder="Brief description of the template..."
            />
            {errors.description && <small className="text-danger">{errors.description}</small>}
          </Form.Group>

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">
              Tags (comma-separated)
            </Form.Label>
            <Form.Control
              type="text"
              value={newTemplate.tags}
              onChange={(e) =>
                setNewTemplate({ ...newTemplate, tags: e.target.value })
              }
              placeholder="e.g. contract, legal, business"
              className="admin-template-input"
            />
          </Form.Group>

          <div className="negotiable-option-card">
            <div className="negotiable-info">
              <span className="negotiable-label">Negotiation Contract</span>
              <span className="negotiable-desc">Enable collaborative editing and negotiation for this template.</span>
            </div>
            <Form.Group className="mb-0">
              <Form.Check 
                type="switch"
                id="is-negotiable-create"
                checked={newTemplate.is_negotiable}
                onChange={(e) =>
                  setNewTemplate({ ...newTemplate, is_negotiable: e.target.checked })
                }
                className="custom-switch"
              />
            </Form.Group>
          </div>
        </div>
      </ModalComponent>

      {/* Edit Template Modal */}
      <ModalComponent
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        title="Edit Template"
        size="md"
        footerButtons={[
          {
            label: "Cancel",
            variant: "outline-secondary",
            onClick: () => setShowEditModal(false),
            disabled: loading,
          },
          {
            label: loading ? "Saving..." : "Save Changes",
            variant: "primary",
            onClick: handleEditTemplate,
            disabled: loading,
          },
        ]}
      >
        <div className='p-4'>
          {errors.general && (
            <div className="text-danger mb-4">{errors.general}</div>
          )}

          {editTemplateData.currentImage && (
            <div className="text-center">
              <img
                src={editTemplateData.currentImage}
                alt="Preview"
                className="admin-template-image-preview"
              />
            </div>
          )}


          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">Update Icon</Form.Label>
            <Form.Control
              type="file"
              accept="image/png,image/jpeg,image/jpg"
              onChange={handleEditFileChange}
              className="admin-template-file-input"
            />
            {errors.icon && <small className="text-danger">{errors.icon}</small>}
          </Form.Group>

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">Title</Form.Label>
            <Form.Control
              type="text"
              value={editTemplateData.title}
              onChange={(e) =>
                setEditTemplateData({
                  ...editTemplateData,
                  title: e.target.value,
                })
              }
              required
              className="admin-template-input"
            />
            {errors.title && <small className="text-danger">{errors.title}</small>}
          </Form.Group>

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={editTemplateData.description}
              onChange={(e) =>
                setEditTemplateData({
                  ...editTemplateData,
                  description: e.target.value,
                })
              }
              className="admin-template-textarea"
            />
            {errors.description && <small className="text-danger">{errors.description}</small>}
          </Form.Group>

          <Form.Group className="admin-template-form-group">
            <Form.Label className="admin-template-form-label">
              Tags (comma-separated)
            </Form.Label>
            <Form.Control
              type="text"
              value={editTemplateData.tags}
              onChange={(e) =>
                setEditTemplateData({
                  ...editTemplateData,
                  tags: e.target.value,
                })
              }
              placeholder="e.g. contract, legal, business"
              className="admin-template-input"
            />
          </Form.Group>

          <div className="negotiable-option-card">
            <div className="negotiable-info">
              <span className="negotiable-label">Negotiation Support</span>
              <span className="negotiable-desc">Allow users to suggest edits and propose changes during the signing workflow.</span>
            </div>
            <Form.Group className="mb-0">
              <Form.Check 
                type="switch"
                id="is-negotiable-edit"
                checked={editTemplateData.is_negotiable}
                onChange={(e) =>
                  setEditTemplateData({
                    ...editTemplateData,
                    is_negotiable: e.target.checked,
                  })
                }
                className="custom-switch"
              />
            </Form.Group>
          </div>
        </div>
      </ModalComponent>


      {/* Delete Confirmation Modal */}
      <ModalComponent
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        title="Delete Template"
        size="md"
        footerButtons={[
          {
            label: "Cancel",
            variant: "outline-secondary",
            onClick: () => setShowDeleteModal(false),
          },
          {
            label: loading ? "Deleting..." : "Delete",
            variant: "danger",
            onClick: deleteTemplate,
            disabled: loading,
          },
        ]}
      >
        <div className='p-4'>
          {errors.general && (
            <div className="text-danger mb-4">{errors.general}</div>
          )}
          <p className="admin-template-delete-message">
            Are you sure you want to delete{" "}
            <strong>{selectedTemplate?.title}</strong>?
          </p>
        </div>
      </ModalComponent>

    </>
  );
};

export default Template;
